document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;

  const stickyNav = document.querySelector(".js-site-navigation");
  const mainHeader = document.querySelector(".js-site-header");
  const siteSearch = document.querySelector(".js-header-site-search");
  const mobileNav = document.querySelector(".site-header__mobile-tools");
  const promo = document.querySelector(".promo-fixed");

  const { universityPressThemeSettings } = window;

  const breakpoint =
    universityPressThemeSettings.fixed_header_breakpoint || 950;

  const hasStickyNav = stickyNav && mainHeader && siteSearch;

  const hasMobileNav = mobileNav;

  const hasPromo = promo && !localStorage.getItem("popupClosed");

  const navTop = stickyNav
    ? stickyNav.getBoundingClientRect().top + window.scrollY
    : 0;

  const navHeight = stickyNav ? stickyNav.offsetHeight : 0;

  const mobileTop = mobileNav
    ? mobileNav.getBoundingClientRect().top + window.scrollY
    : 0;

  const getPromoHeight = () =>
    hasPromo && promo.isConnected ? promo.offsetHeight : 0;

  const updateDesktop = () => {
    const scrollY = window.scrollY;

    let offset = 0;

    //
    // Promo
    //
    if (hasPromo && promo.isConnected) {
      if (scrollY > 0) {
        promo.classList.add("fixed");
        offset = promo.offsetHeight;
      } else {
        promo.classList.remove("fixed");
      }
    }

    //
    // Sticky nav
    //
    if (hasStickyNav && scrollY >= navTop) {
      body.classList.add("fixed-header");

      stickyNav.classList.add("fixed-nav");
      stickyNav.style.top = `${offset}px`;

      siteSearch.classList.add("fixed-nav");
      siteSearch.style.top = `${offset + navHeight}px`;

      mainHeader.style.paddingBottom = `${navHeight}px`;
    } else if (hasStickyNav) {
      body.classList.remove("fixed-header");

      stickyNav.classList.remove("fixed-nav");
      stickyNav.style.top = "";

      siteSearch.classList.remove("fixed-nav");
      siteSearch.style.top = "";

      mainHeader.style.paddingBottom = "";
    }
  };

  const updateMobile = () => {
    if (!hasMobileNav) return;

    const scrollY = window.scrollY;
    let offset = 0;

    if (hasPromo && promo.isConnected) {
      if (scrollY > 0) {
        promo.classList.add("fixed");
        offset = getPromoHeight();
      } else {
        promo.classList.remove("fixed");
      }
    }

    if (scrollY >= mobileTop && scrollY !== 0) {
      mobileNav.classList.add("fixed-nav-mob");
      mobileNav.style.top = offset ? `${offset}px` : "";
    } else {
      mobileNav.classList.remove("fixed-nav-mob");
      mobileNav.style.top = "";
    }
  };

  const update = () => {
    if (window.innerWidth >= breakpoint) {
      updateDesktop();
    } else {
      updateMobile();
    }
  };

  window.addEventListener("scroll", update);
  window.addEventListener("resize", update);
  window.addEventListener("promoClosed", update);

  update();
});
